export function scrollToResult(offset = false) {
  let resultBlock = document.querySelector(".result-block"),
    scrollHeight = resultBlock.clientHeight,
    scrollTo =
      resultBlock.offsetTop + scrollHeight - window.innerHeight / 2 + 40;
  if (offset) {
    scrollTo = resultBlock.offsetTop;
  }
  window.scroll(0, scrollTo);
}
export function haeElementti(nimi) {
  var el = document.getElementsByName(nimi);

  if (el && el.length > 1) {
    for (let x = 0; x < el.length; x++) {
      if (el[x].checked) {
        return el[x];
      }
    }

    return null;
  }

  el = document.getElementById(nimi);

  if (el) {
    return el;
  } else {
    return null;
  }
}

export function asetaArvo(nimi, arvo) {
  var el = haeElementti(nimi);
  el.value = arvo;
}

export function asetaTeksti(nimi, teksti) {
  var el = haeElementti(nimi);
  el.innerHTML = teksti;
}

export function parsiNumero(arvo) {
  return arvo ? parseFloat(arvo.replace(",", ".")) : null;
}

export function tarkistaVali(arvo, min, max) {
  return !(arvo >= min && arvo <= max);
}

export function haeArvo(nimi) {
  var el = haeElementti(nimi);
  return el ? el.value : null;
}

export function naytaHuomautus(nimi, huomautus) {
  var el = document.getElementById(nimi);
  el.innerHTML = huomautus;
  el.style.display = huomautus ? "block" : "none";
}

export function asetaValintaArvo(nimi, arvo) {
  var el = document.getElementsByName(nimi);

  if (el && el.length > 0) {
    for (var x = 0; x < el.length; x++) {
      if (el[x].value == arvo) {
        el[x].checked = true;
      }
    }
  } else {
    el = haeElementti(nimi);

    el.value = arvo;
  }
}

export function naytaTulos(tulosikkuna, tulos) {
  document.getElementById(tulosikkuna).innerHTML = tulos;
}

export function haeParametri(nimi) {
  var regexS = "[\\?&]" + nimi + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var tmpURL = document.location.href;
  var results = regex.exec(tmpURL);

  if (results === null) {
    return "";
  } else {
    return results[1];
  }
}

export function asetaFokus(nimi) {
  document.getElementById(nimi).focus();
}

/*----------------------------------------------- SCORE ---------------------------------------------------------------*/

export function handler_apgar() {
  var a = parseInt(document.getElementById("ans0_apgar").value),
    b = parseInt(document.getElementById("ans1_apgar").value),
    c = parseInt(document.getElementById("ans2_apgar").value),
    e = parseInt(document.getElementById("ans3_apgar").value),
    d = parseInt(document.getElementById("ans4_apgar").value);
  a = a + b + c + e + d;
  show_success(
    "result_apgar",
    "<strong>" + a + "</strong> " + getRightNameMark(a)
  );
}

export function handler_timi() {
  var a = 0;
  document.getElementById("ans1_timi").checked && a++;
  document.getElementById("ans2_timi").checked && a++;
  document.getElementById("ans3_timi").checked && a++;
  document.getElementById("ans4_timi").checked && a++;
  document.getElementById("ans5_timi").checked && a++;
  document.getElementById("ans6_timi").checked && a++;
  document.getElementById("ans7_timi").checked && a++;
  switch (a) {
    case 0:
      var b = "4.7%";
      break;
    case 1:
      b = "4.7%";
      break;
    case 2:
      b = "8.3%";
      break;
    case 3:
      b = "13.2%";
      break;
    case 4:
      b = "19.9%";
      break;
    case 5:
      b = "26.2%";
      break;
    case 6:
      b = "40.9%";
      break;
    case 7:
      b = "40.9%";
  }
  a =
    "Набрано <strong>" +
    a +
    " " +
    getRightNameMark(a) +
    "</strong>. Риск смерти или инфаркта в ближайшие 2 недели <strong>" +
    b +
    "</strong>";
  show_success("result_timi", a);
}

export function handler_hasbled() {
  var a = 0;
  document.getElementById("ans1_hasbled").checked && a++;
  document.getElementById("ans2_hasbled").checked && a++;
  document.getElementById("ans3_hasbled").checked && a++;
  document.getElementById("ans4_hasbled").checked && a++;
  document.getElementById("ans5_hasbled").checked && a++;
  document.getElementById("ans6_hasbled").checked && a++;
  document.getElementById("ans7_hasbled").checked && a++;
  document.getElementById("ans8_hasbled").checked && a++;
  document.getElementById("ans9_hasbled").checked && a++;
  var b = "";
  3 <= a &&
    (b =
      "Высокий риск кровотечения, применение любого антитромботического препарата требует особой осторожности.");
  a = "Набрано <strong>" + a + " " + getRightNameMark(a) + "</strong>. " + b;
  show_success("result_hasbled", a);
}

export function handler_chads() {
  var a = 0;
  document.getElementById("ans1_chads").checked && (a += 2);
  document.getElementById("ans2_chads").checked && a++;
  document.getElementById("ans3_chads").checked && a++;
  document.getElementById("ans4_chads").checked && a++;
  document.getElementById("ans5_chads").checked && a++;
  switch (a) {
    case 0:
      var b = "1.9 (1.2-3.0)%";
      break;
    case 1:
      b = "2.8 (2.0-3.8)%";
      break;
    case 2:
      b = "4.0 (3.1-5.1)%";
      break;
    case 3:
      b = "5.9 (4.6-7.3)%";
      break;
    case 4:
      b = "8.5 (6.3-11.1)%";
      break;
    case 5:
      b = "12.5 (8.2-17.5)%";
      break;
    case 6:
      b = "18.2 (10.5-27.4)%";
  }
  a =
    "Набрано <strong>" +
    a +
    " " +
    getRightNameMark(a) +
    "</strong>. Ожидаемая частота инсультов за год ";
  show_success(
    "result_chads",
    a + ("(в среднем и 95% доверительный интервал) <strong>" + b + "</strong>.")
  );
}

export function handler_chadsvasc() {
  var a = 0;
  document.getElementById("ans1_chadsvasc").checked && a++;
  document.getElementById("ans2_chadsvasc").checked && a++;
  document.getElementById("ans3_chadsvasc").checked && (a += 2);
  document.getElementById("ans4_chadsvasc").checked && a++;
  document.getElementById("ans5_chadsvasc").checked && (a += 2);
  document.getElementById("ans6_chadsvasc").checked && a++;
  document.getElementById("ans7_chadsvasc").checked && a++;
  document.getElementById("ans8_chadsvasc").checked && a++;
  var b =
    "Рекомендуется прием витамина К (например, варфарин) с целевым МНО 2.5 (2.0-3.0)";
  switch (a) {
    case 0:
      var c = "0%";
      b =
        "Рекомендуется прием аспирина 75-325мг в сутки или отсутствие антитромботической терапии";
      break;
    case 1:
      c = "1.3%";
      b =
        "Рекомендуется прием перорального антикоагулянта или аспирина 75-325мг в сутки";
      break;
    case 2:
      c = "2.2%";
      break;
    case 3:
      c = "3.2%";
      break;
    case 4:
      c = "4.0%";
      break;
    case 5:
      c = "6.7%";
      break;
    case 6:
      c = "9.8%";
      break;
    case 7:
      c = "9.6%";
      break;
    case 8:
      c = "6.7%";
      break;
    case 9:
      c = "15.2%";
  }
  a =
    "Набрано <strong>" +
    a +
    " " +
    getRightNameMark(a) +
    "</strong>. Ожидаемая частота инсультов за год - <strong>" +
    c +
    "</strong>";
  show_success("result_chadsvasc", a + (".<br/>" + b));
}

export function handler_sofa() {
  var a = getNumberRight("pao2", "sofa", "PaO<sub>2</sub>", 5, 1e3);
  if (a) {
    var b = getNumberRight("fio2", "sofa", "FiO<sub>2</sub>", 0, 100);
    if (b) {
      var c = getNumberRight("tromb", "sofa", "Тромбоциты", 0, 1e3);
      if (c) {
        var e = getNumberRight("bilir", "sofa", "Билирубин", 0, 1e3);
        if (e) {
          if (document.getElementById("type_kreatinin_sofa").checked) {
            var d = getNumberRight("ren", "sofa", "Креатинин крови", 5, 3e3);
            if (!d) return;
            var f = "kr";
          } else {
            d = getNumberRight("ren", "sofa", "Суточный диурез", 0, 1e4);
            if (!d) return;
            f = "di";
          }
          var g = document.getElementById("ans1_sofa").value,
            h = document.getElementById("ans2_sofa").value,
            k = document.getElementById("ans3_sofa").value,
            l = document.getElementById("ans4_sofa").value;
          toAjax("sofa", {
            sender: "sofa_scale",
            typeRen: f,
            pao2: a,
            fio2: b,
            tromb: c,
            bilir: e,
            ren: d,
            ans1: g,
            ans2: h,
            ans3: k,
            ans4: l,
          });
        }
      }
    }
  }
}

export function handler_chipu() {
  var a = document.getElementById("ans1_chipu").value,
    b = document.getElementById("ans2_chipu").value,
    c = document.getElementById("ans3_chipu").value,
    e = document.getElementById("ans4_chipu").value,
    d = document.getElementById("ans5_chipu").value;
  a =
    parseInt(a, 10) +
    parseInt(b, 10) +
    parseInt(c, 10) +
    parseInt(e, 10) +
    parseInt(d, 10);
  if (5 == a || 6 == a)
    var f = "A",
      g = "100",
      h = "85";
  else
    7 <= a && 9 >= a
      ? ((f = "B"), (g = "81"), (h = "57"))
      : 10 <= a && 15 >= a && ((f = "C"), (g = "45"), (h = "35"));
  var text = "<strong>" + a + " " + getRightNameMark(a) + "</strong>. ";
  text +=
    "Класс по Чайлд-Пью <strong>" +
    f +
    "</strong> (<strong>Child " +
    f +
    "</strong>). ";
  text +=
    "Годичная выживаемость <strong>" +
    g +
    "%</strong>. Двухлетняя выживаемость <strong>" +
    h +
    "%</strong>.";
  show_success("result_chipu", text);
}

export function handler_hhess() {
  for (var a, b = 1; 5 >= b; b++)
    document.getElementById("ans" + b + "_hhess").checked && (a = b);
  document.getElementById("ans6_hhess").checked && a++;
  switch (a) {
    case 1:
      var c = 30;
      break;
    case 2:
      c = 40;
      break;
    case 3:
      c = 50;
      break;
    case 4:
      c = 80;
      break;
    case 5:
      c = 90;
      break;
    case 6:
      c = 90;
  }
  b =
    3 > a
      ? "При выявлении аневризмы возможно проведение незамедлительного оперативного лечения"
      : "При выявлении аневризмы проводится консервативное лечение до достижения 2-х или 1-го балла по шкале";
  var text =
    "<strong>" +
    a +
    " " +
    getRightNameMark(a) +
    "</strong>. " +
    b +
    ". Риск хирургической летальности - <strong>" +
    c +
    "%</strong>";
  show_success("result_hhess", text);
}

export function handler_meanad() {
  var a = getNumberRight("sist", "meanad", "Систолическое АД", 0, 350);
  if (a) {
    var b = getNumberRight("diast", "meanad", "Диастолическое АД", 0, 350);
    if (b) {
      a = Math.round((1 * a) / 3 + (2 * b) / 3);
      var c;
      70 > a
        ? (c =
            a +
            " мм.рт.ст. Пониженное артериальное давление. Возможна гипоксия и ишемия тканей")
        : 70 <= a && 110 >= a
        ? (c = a + " мм.рт.ст. Норма")
        : 110 < a && (c = a + " мм.рт.ст. Повышенное артериальное давление");
      show_success("result_meanad", c);
    }
  }
}

export function handler_eglevit() {
  var a = getNumberRight("growth", "eglevit", "рост", 50, 240);
  if (a) {
    var b = getNumberRight("age", "eglevit", "возраст", 1, 110);
    if (b) {
      var c = document.getElementById("habitus_eglevit").value;
      "" == c
        ? show_error(
            "result_eglevit",
            "Не выбрано поле <strong>телосложение</strong>"
          )
        : toAjax("eglevit", {
            sender: "ideal_eglevit",
            growth: a,
            gender: getSex("eglevit"),
            age: b,
            habitus: c,
          });
    }
  }
}

export function handler_ketle() {
  var a = getNumberRight("growth", "ketle", "Рост", 50, 240);
  if (a) {
    var b = getNumberRight("age", "ketle", "Возраст", 1, 110);
    if (b) {
      var c = getNumberRight("weight", "ketle", "Вес", 15, 250);
      if (c) {
        var e = document.getElementById("habitus_ketle").value;
        "" == e
          ? show_error(
              "result_ketle",
              "Не выбрано поле <strong>Телосложение</strong>"
            )
          : toAjax("ketle", {
              sender: "ideal_ketle",
              growth: a,
              gender: getSex("ketle"),
              age: b,
              weight: c,
              habitus: e,
            });
      }
    }
  }
}

export function handler_lorens() {
  var a = getNumberRight("growth", "lorens", "Рост", 50, 240);
  a && toAjax("lorens", { sender: "ideal_lorens", growth: a });
}

export function handler_broke() {
  var a = getNumberRight("growth", "broke", "Рост", 50, 240);
  a &&
    toAjax("broke", {
      sender: "ideal_broke",
      growth: a,
      gender: getSex("broke"),
    });
}

export function handler_birth() {
  var a = jQuery.trim(document.getElementById("dateMenses_birth").value);
  if ("" == a) show_error("result_birth", "Не введена дата");
  else if (isDate(a)) {
    var b = new Date(
      a.substr(3, 2) + "-" + a.substr(0, 2) + "-" + a.substr(6, 4)
    );
    a = new Date(a.substr(3, 2) + "-" + a.substr(0, 2) + "-" + a.substr(6, 4));
    document.getElementById("menses_birth").checked
      ? a.setDate(b.getDate() + 280)
      : a.setDate(b.getDate() + 266);
    b = Math.ceil((a - new Date()) / 864e5);
    var c;
    0 > b
      ? (c = "")
      : 0 == b
      ? (c = " День родов - <strong>сегодня</strong>.")
      : 0 < b &&
        (c = " Дней оставшихся до родов - <strong>" + b + "</strong>.");
    c =
      "Предполагаемая дата родов - <strong>" +
      a.toLocaleString("ru", {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      }) +
      "</strong>" +
      c;
    show_success("result_birth", c);
  } else
    show_error(
      "result_birth",
      'Неправильный формат даты. Дата должна вводится в формате "дд.мм.гггг"'
    );
}

export function handler_grace() {
  var a = getNumberRight("age", "grace", "Возраст", 1, 110);
  if (a) {
    var b = getNumberRight("rate", "grace", "ЧСС", 1, 350);
    if (b) {
      var c = getNumberRight("pressure", "grace", "Систолическое АД", 0, 350);
      if (c) {
        var e = getNumberRight("kreatinin", "grace", "Креатинин", 10, 5e3);
        if (e) {
          var d = document.getElementById("ans1_grace").value,
            f = document.getElementById("ans2_grace").value,
            g = document.getElementById("ans3_grace").value,
            h = document.getElementById("ans4_grace").value;
          toAjax("grace", {
            sender: "grace",
            age: a,
            rate: b,
            pressure: c,
            kreatinin: e,
            ans1: d,
            ans2: f,
            ans3: g,
            ans4: h,
          });
        }
      }
    }
  }
}

export function handler_fager() {
  var a = document.getElementById("ans0_fager").value,
    b = document.getElementById("ans1_fager").value,
    c = document.getElementById("ans2_fager").value,
    e = document.getElementById("ans3_fager").value,
    d = document.getElementById("ans4_fager").value,
    f = document.getElementById("ans5_fager").value;
  if ("" == a || "" == b || "" == c || "" == e || "" == d || "" == f)
    show_error("result_fager", "Не выбрано одно из полей. Расчет невозможен.");
  else {
    a =
      parseInt(a, 10) +
      parseInt(b, 10) +
      parseInt(c, 10) +
      parseInt(e, 10) +
      parseInt(d, 10) +
      parseInt(f, 10);
    b = "";
    0 <= a && 2 >= a
      ? (b = "очень слабая зависимость")
      : 3 <= a && 4 >= a
      ? (b = "слабая зависимость")
      : 5 == a
      ? (b = "слабая зависимость")
      : 6 <= a && 7 >= a
      ? (b = "высокая зависимость")
      : 8 <= a && 10 >= a && (b = "очень высокая зависимость");
    var g;
    3 >= a
      ? (g =
          "При решении прекратить курение основное внимание должно быть уделено психологическим факторам.")
      : 4 == a || 5 == a
      ? (g =
          "При решении прекратить курение желательно использование препаратов замещения никотина.")
      : 6 <= a &&
        10 >= a &&
        (g =
          "При решении прекратить курение резкий отказ от курения может вызвать неприятные ощущения в организме. Справиться с ними помогут препараты замещения никотина.");
    show_success(
      "result_fager",
      "Набрано <strong>" +
        a +
        " " +
        getRightNameMark(a) +
        "</strong> - " +
        b +
        ". " +
        g
    );
  }
}

export function handler_dlp() {
  var a = [1, 1.1, 1.3, 1.7, 2.2, 2.6],
    b = [1, 1.1, 1.4, 1.6, 1.9, 2.2],
    c = [1, 1.1, 1.5, 1.6, 2, 2.4],
    e = [0.0023, 0.0054, 0.017, 0.015, 0.019],
    d = document.getElementById("region_dlp").value,
    f = document.getElementById("age_dlp").value,
    g = getNumberRight("dosis", "dlp", "Поглощенная доза", 0, 1e6);
  if (g) {
    var h = 1;
    0 == d || 1 == d ? (h = a[f]) : 2 == d && (h = b[f]);
    if (3 == d || 4 == d) h = c[f];
    show_success(
      "result_dlp",
      "Эффективная доза: <strong>" + rnd(g * e[d] * h) + " мЗв</strong>"
    );
  }
}

export function handler_smoke() {
  var a = getNumberRight("count", "smoke", "Количество сигарет в день", 0, 200);
  if (a) {
    var b = getNumberRight("stage", "smoke", "Стаж курения", 0, 100);
    b &&
      ((a = rnd((a * b) / 20)),
      (b = "Индекс курения: <strong>" + a + "</strong>. Индекс курения "),
      10 < a
        ? show_success(
            "result_smoke",
            b + "больше 10, имеется достоверный фактор развития ХОБЛ."
          )
        : show_success(
            "result_smoke",
            b + "меньше 10, вы не входите в группу риска развития ХОБЛ."
          ));
  }
}

export function DoIt(a, b, c, e, d) {
  b = convert(b);
  c = convert(c);
  d = convert(d);
  if (0 == a)
    var f = -21,
      g = 4.62;
  else (f = -28.7), (g = 6.23);
  var h = Math.exp(-Math.exp(f) * Math.pow(b - 20, g)),
    k = Math.exp(-Math.exp(f) * Math.pow(b - 10, g));
  0 == a ? ((f = -25.7), (g = 5.47)) : ((f = -30), (g = 6.42));
  a = Math.exp(-Math.exp(f) * Math.pow(b - 20, g));
  b = Math.exp(-Math.exp(f) * Math.pow(b - 10, g));
  f = 0.24 * (d - 6) + 0.018 * (c - 120) + 0.71 * e;
  c = 0.02 * (d - 6) + 0.022 * (c - 120) + 0.63 * e;
  return (
    100 *
    (1 -
      Math.pow(k, Math.exp(f)) / Math.pow(h, Math.exp(f)) +
      (1 - Math.pow(b, Math.exp(c)) / Math.pow(a, Math.exp(c))))
  );
}

export function CheckAge(a) {
  return "" == a
    ? (show_error("result_score", "Возраст не задан!"), !1)
    : IsPositiveNumber(a)
    ? 20 > a || 65 < a
      ? (show_error(
          "result_score",
          "Возраст должен быть в пределах от 20 до 65 лет!"
        ),
        !1)
      : !0
    : (show_error("result_score", "Возраст: неверный ввод!"), !1);
}

export function CheckChol(a) {
  return "" == a
    ? (show_error("result_score", "Уровень холестерина: неверный ввод!"), !1)
    : IsPositiveNumber(a)
    ? 3 > a || 8 < a
      ? (show_error(
          "result_score",
          "Уровень холестерина должен быть в пределах от 3 до 8 ммоль/л!"
        ),
        !1)
      : !0
    : (show_error(
        "result_score",
        "Уровень холестерина должен быть задан положительным числом!"
      ),
      !1);
}

export function CheckAD(a) {
  return "" == a
    ? (show_error("result_score", "Уровень систолического АД не задан!"), !1)
    : IsPositiveNumber(a)
    ? 100 > a || 180 < a
      ? (show_error(
          "result_score",
          "Уровень систолического АД должен быть в пределах от 100 до 180 мм рт.ст.!"
        ),
        !1)
      : !0
    : (show_error("result_score", "Уровень систолического АД: неверный ввод!"),
      !1);
}

export function IsPositiveNumber(a) {
  var b = 0;
  for (let i = 0; i < a.length; i++) {
    var c = a.charAt(i);
    if ("0" > c || "9" < c) {
      if (("." != c && "," != c) || 1 == b) return !1;
      b++;
    }
  }
  return !0;
}

export function convert(a) {
  var b,
    c = "";
  for (b = 0; b < a.length; b++)
    c = "," == a.charAt(b) ? c + "." : c + a.charAt(b);
  return c;
}

export function rnd(a) {
  return Math.round(100 * a) / 100;
}

export function handler_score() {
  var a = document.getElementById("age_score").value;
  if (CheckAge(a)) {
    var b = document.getElementById("pressure_score").value;
    if (CheckAD(b)) {
      var c = document.getElementById("chole_score").value;
      if (CheckChol(c)) {
        var e = document.getElementById("smoke_score").value,
          d = 0;
        document.getElementById("female_score").checked && (d = 1);
        show_success_score("result_score", rnd(DoIt(d, a, b, e, c)));
      }
    }
  }
}

export function handler_glaz() {
  var a = document.getElementById("open-eye_glaz").value,
    b = document.getElementById("voice-response_glaz").value,
    c = document.getElementById("motor-reaction_glaz").value;
  toAjax("glaz", { sender: "glazgo", openEye: a, voice: b, motor: c });
}

export function handler_sqr() {
  var a = document.getElementById("formula_sqr").value,
    b = getNumberRight("growth", "sqr", "Рост", 90, 240);
  if (b) {
    var c = getNumberRight("weight", "sqr", "Вес", 15, 250);
    c &&
      toAjax("sqr", {
        sender: "square_body",
        weight: c,
        growth: b,
        formula: a,
      });
  }
}

export function handler_iw() {
  var a = getNumberRight("growth", "iw", "Рост", 90, 240);
  if (a) {
    var b = getNumberRight("weight", "iw", "Вес", 15, 250);
    b && toAjax("iw", { sender: "ind_weight", weight: b, growth: a });
  }
}

export function handler_fl() {
  var a = getNumberRight("growth", "fl", "Рост", 80, 240);
  if (a) {
    var b = getNumberRight("waist", "fl", "Окружность талии", 15, 1e3);
    if (b) {
      var c = getNumberRight("neck", "fl", "Окружность шеи", 15, 1e3);
      if (c) {
        var e = getSex("fl");
        if ("female" == e) {
          var d = getNumberRight("femur", "fl", "Окружность бедер", 15, 1e3);
          if (!d) return;
        }
        toAjax("fl", {
          sender: "fat_level",
          waist: b,
          growth: a,
          neck: c,
          femur: d,
          gender: e,
        });
      }
    }
  }
}

export function handler_bov() {
  var a = document.getElementById("koeff_bov").value,
    b = getNumberRight("growth", "bov", "Рост", 80, 240);
  if (b) {
    var c = getNumberRight("age", "bov", "Возраст", 10, 110);
    if (c) {
      var e = getNumberRight("weight", "bov", "Вес", 20, 240);
      e &&
        toAjax("bov", {
          sender: "bov",
          weight: e,
          growth: b,
          age: c,
          koeff: a,
          gender: getSex("bov"),
        });
    }
  }
}

export function handler_skf() {
  var a = getNumberRight("age", "skf", "Возраст", 10, 120);
  if (a) {
    var b = getNumberRight("weight", "skf", "Вес", 15, 250);
    if (b) {
      var c = getNumberRight("kreatinin", "skf", "Креатинин", 5, 5e3);
      if (c) {
        var e = document.getElementById("formula_skf").value;
        if (1 == e) {
          var d = getNumberRight("growth", "skf", "Рост", 80, 240);
          if (!d) return;
        }
        toAjax("skf", {
          sender: "skf",
          formula: e,
          weight: b,
          age: a,
          kreatinin: c,
          growth: d,
          gender: getSex("skf"),
        });
      }
    }
  }
}

export function handler_skf_child() {
  var a = getNumberRight("age", "skf_child", "Возраст", 0, 18);
  if (a) {
    var b = getNumberRight("growth", "skf_child", "Рост", 20, 180);
    if (b) {
      var c = getNumberRight("kreatinin", "skf_child", "Креатинин", 5, 5e3);
      c &&
        toAjax("skf_child", {
          sender: "skf_child",
          age: a,
          kreatinin: c,
          growth: b,
          gender: getSex("skf_child"),
        });
    }
  }
}

export function handler_alc() {
  var a = getNumberRight("weight", "alc", "Вес", 15, 250);
  if (a) {
    var b = getNumberRight("strength", "alc", "Крепость напитка", 0.01, 100);
    if (b) {
      var c = getNumberRight("amount", "alc", "Количество", 1, 15e3);
      c &&
        toAjax("alc", {
          sender: "alc",
          weight: a,
          amount: c,
          strength: b,
          gender: getSex("alc"),
        });
    }
  }
}

export function show_result(a, b) {
  var c = b.substring(0, 1);
  b = b.substring(1, b.length);
  "1" == c ? show_success(a, b) : show_error(a, b);
}

export function checkStr(a) {
  return /(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]+$)/i.test(a);
}

export function isDate(a) {
  a = (a + "").split(".");
  return 3 != a.length ||
    1990 >= parseInt(a[2], 10) ||
    2020 <= parseInt(a[2], 10)
    ? !1
    : "Invalid Date" == new Date(a[2] + "-" + a[1] + "-" + a[0])
    ? !1
    : !0;
}

export function show_success(a, b) {
  b =
    '<div class="alert alert-dismissible alert-info"><button type="button" class="close" data-dismiss="alert">×</button>' +
    b +
    "</div>";
  document.getElementById(a).innerHTML = b;
}

export function show_success_score(a, b) {
  var c = Math.round(b),
    e,
    d = '<div class="alert alert-dismissible score_result color_';
  15 <= c
    ? (d += '7">')
    : 15 > c && 10 <= c
    ? (d += '6">')
    : 10 > c && 5 <= c
    ? (d += '5">')
    : 5 > c && 3 <= c
    ? (d += '4">')
    : 3 > c && 2 <= c
    ? (d += '3">')
    : 2 > c && 1 <= c
    ? (d += '2">')
    : 1 > c && (d += '1">');
  10 <= c
    ? (e = "очень высокий")
    : 10 > c && 5 <= c
    ? (e = "высокий")
    : 5 > c && 1 <= c
    ? (e = "умеренный")
    : 1 > c && (e = "низкий");
  d =
    d +
    '<button type="button" class="close" data-dismiss="alert">×</button>Десятилетний фатальный риск: <strong>' +
    b +
    "%</strong><br/>Риск: <strong>" +
    e +
    "</strong></div>";
  document.getElementById(a).innerHTML = d;
}

export function show_error(a, b) {
  b =
    '<div class="alert alert-dismissible alert-danger"><button type="button" class="close" data-dismiss="alert">×</button>' +
    b +
    "</div>";
  document.getElementById(a).innerHTML = b;
}

export function setVisible_fl() {
  var a = document.getElementById("femur_fl"),
    b = document.getElementById("lbl_femur_fl");
  document.getElementById("male_fl").checked
    ? ((a.style.visibility = "hidden"), (b.style.visibility = "hidden"))
    : ((a.style.visibility = "visible"), (b.style.visibility = "visible"));
}

export function change_skf() {
  var a = document.getElementById("growth_skf"),
    b = document.getElementById("lbl_growth_skf");
  "1" != document.getElementById("formula_skf").value
    ? ((a.style.visibility = "hidden"), (b.style.visibility = "hidden"))
    : ((a.style.visibility = "visible"), (b.style.visibility = "visible"));
}

export function setVisible_glaz() {
  var a = document.getElementById("voice-response_glaz");
  document.getElementById("adult_glaz").checked
    ? ((a.options[0] = new Option(
        "Больной ориентирован, быстрый и правильный ответ на заданный вопрос",
        "5"
      )),
      (a.options[1] = new Option(
        "Больной дезориентирован, спутанная речь",
        "4"
      )),
      (a.options[2] = new Option(
        "Словесная окрошка, ответ по смыслу не соответствует вопросу",
        "3"
      )),
      (a.options[3] = new Option(
        "Нечленораздельные звуки в ответ на заданный вопрос",
        "2"
      )),
      (a.options[4] = new Option("Отсутствие речи", "1")))
    : ((a.options[0] = new Option(
        "Ребёнок улыбается, ориентируется на звук, следит за объектами, интерактивен",
        "5"
      )),
      (a.options[1] = new Option(
        "Ребёнка при плаче можно успокоить, интерактивность неполноценная",
        "4"
      )),
      (a.options[2] = new Option(
        "При плаче успокаивается, но ненадолго, стонет",
        "3"
      )),
      (a.options[3] = new Option("Плач и интерактивность отсутствуют", "2")),
      (a.options[4] = new Option("Речевая реакция", "1")));
}

export function setVisible_sofa() {
  document.getElementById("type_kreatinin_sofa").checked
    ? (document.getElementById("lbl_ren_sofa").innerHTML =
        "Креатинин крови, мкмоль/л")
    : (document.getElementById("lbl_ren_sofa").innerHTML =
        "Суточный диурез, мл/сут");
}

export function setVisible_birth() {
  document.getElementById("menses_birth").checked
    ? ((document.getElementById("lbl_dateMenses_birth").innerHTML =
        "Дата первого дня последней менструации"),
      (document.getElementById("dateMenses_birth").placeholder =
        "Дата первого дня последней менструации"))
    : ((document.getElementById("lbl_dateMenses_birth").innerHTML =
        "Дата зачатия"),
      (document.getElementById("dateMenses_birth").placeholder =
        "Дата зачатия"));
}

export function getRightNameMark(a) {
  a = a.toString();
  2 < a.length && (a = a.substr(a.length - 2, 2));
  if (2 == a.length && "1" == a.substr(0, 1)) return "баллов";
  a = a.substr(a.length - 1, 1);
  return "1" == a
    ? "балл"
    : "2" == a || "3" == a || "4" == a
    ? "балла"
    : "баллов";
}

export function getNumberRight(a, b, c, e, d) {
  a = jQuery.trim(document.getElementById(a + "_" + b).value);
  return !checkStr(a) || a < e || a > d
    ? (show_error(
        "result_" + b,
        "Некорректные данные в поле <strong>" + c + "</strong>"
      ),
      !1)
    : a;
}

export function getSex(a) {
  return document.getElementById("male_" + a).checked ? "male" : "female";
}

export function toAjax(a, b) {
  window.jQuery &&
    jQuery.ajax({
      type: "POST",
      url: "/plugins/content/medsoftprocalcs/responser.php",
      data: b,
      success: function (b) {
        show_result("result_" + a, b);
      },
    });
}

export function handler_clear() {
  document.getElementById("result_" + arguments[0]).innerHTML = "";
  for (var a = 1; a < arguments.length; a++) {
    var b = document.getElementById(arguments[a] + "_" + arguments[0]);
    "text" == b.type
      ? (b.value = "")
      : "select-one" == b.type
      ? (b.options[0].selected = "true")
      : "radio" == b.type
      ? (b.checked = !0)
      : "checkbox" == b.type && (b.checked = !1);
  }
}

export function checkBox(a, b) {
  "chadsvasc" == b
    ? ("ans3" == a
        ? (document.getElementById("ans7_chadsvasc").checked = !1)
        : "ans7" == a &&
          (document.getElementById("ans3_chadsvasc").checked = !1),
      handler_chadsvasc())
    : "chads" == b
    ? handler_chads()
    : "hasbled" == b
    ? handler_hasbled()
    : "timi" == b && handler_timi();
}
